import * as log from "loglevel";
import { v4 as uuidv4 } from "uuid";

const key = "portal-unique-id";

/**
 * Obtain a unique id for the current browser window / tab.
 * inspired by https://github.com/dfbaskin/browser-tab-unique-id/blob/master/src/unique-id.js
 */
export function getUniqueIdForApplication() {
  let value = window.sessionStorage.getItem(key);

  let parentValue: string | null = null;
  try {
    // Access parentValue only if window.opener is from same-origin
    parentValue =
      window.opener?.location.origin === window.location.origin
        ? window.opener.sessionStorage.getItem(key)
        : null;
  } catch (err) {
    log.warn("Could not access window.opener due to cross-origin policy.", err);
  }

  if (!value || !window.name || parentValue === value) {
    value = uuidv4();
    window.sessionStorage.setItem(key, value);
  }

  window.name = value;
  return value;
}
